import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      class="design-iconfont"
      width={width}
      height={height}
    >
      <path
        fill={color}
        d="M2,4.01746052 L2,3.01746052 L14,3.01746052 L14,4.01746052 L2,4.01746052 Z M2,8.5 L2,7.5 L14,7.5 L14,8.5 L2,8.5 Z M14,13.00239 L14,12.00239 L2,12.00239 L2,13.00239 L14,13.00239 Z"
        fill-opacity=".9"
        fill-rule="evenodd"
      />
    </svg>
  )
}
const FontJustifyIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default FontJustifyIcon
